/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Output} from '@angular/core';
import {SearchResultsOverlayRef} from './search-results.overlay-ref';
import {SEARCH_RESULTS_DATA} from './search-results.symbols';

@Component({
    selector: 'dash-gis-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: [ './search-results.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsComponent {

    @Output() public backToSearch: EventEmitter<void> = new EventEmitter<void>();
    @Output() public closeResults: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        @Inject(SearchResultsOverlayRef) private overlayRef: SearchResultsOverlayRef,
        @Inject(SEARCH_RESULTS_DATA) private opts: any,
    ) {

    }

    public close() {
        this.overlayRef.close();
    }

    get instanceId() {
        return this.opts.id;
    }
    get params() {
        return this.opts.params;
    }
}
